import type BaseEnumType from "@/app/services/baseEnumType";
import type Guid from "@/app/types/common/guid";

export interface SnackbarConfiguration {
  id: Guid;
  text: string;
  timeout: number;
  position: "top" | "bottom";
  type?: EnumSnackbarType;
}

export class EnumSnackbarType implements BaseEnumType {
  private static allValues: EnumSnackbarType[] = []; // make sure this is top-most
  public static none = new EnumSnackbarType(0, "None", "brand01");
  public static info = new EnumSnackbarType(1, "Info", "brand01");
  public static warning = new EnumSnackbarType(2, "Warning", "warning");
  public static error = new EnumSnackbarType(3, "Error", "errorMedium");
  public static success = new EnumSnackbarType(4, "Success", "success");
  public key: number;
  public value: string;
  public colour: string;

  private constructor(key: number, value: string, colour: string) {
    this.key = key;
    this.value = value;
    this.colour = colour;

    EnumSnackbarType.allValues.push(this);
  }

  public static getValues(): EnumSnackbarType[] {
    return EnumSnackbarType.allValues;
  }

  public static getByKey(key: number): EnumSnackbarType {
    const found = EnumSnackbarType.allValues.find((e) => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumSnackbarType - Key not found: ${key}`);
    }

    return found;
  }
}
